module.exports = __webpack_public_path__ + "media/images/icons/check-gray-efd96705601c881984dd76870edaa000.svg";